import React, { useEffect } from 'react'
import {Route, useHistory  } from 'react-router-dom'
import { useAuth } from '../services/AuthService';
import constants from '../constants/constants';
import Cookies from 'js-cookie';
import Candidates from "../views/Candidates";
import MultiCandidateAdmin from '../views/sub-buyer-admin/MultiCandidateAdmin';
import YourJobsContainer from '../views/jobs/YourJobsContainer';
import MultiCostCenter from '../views/sub-buyer-admin/MultiCostCenter';
import MultiYourJobsContainer from '../views/sub-buyer-admin/MultiYourJobsContainer';
/**
 *
 * @param {Object} Route parameters
 * @description Route parameters must contain layout, component and other props. Layout has to be the master oage.
 */
export function RouteWithLayout({ layout, auth, component, path, ...rest }) {
    const{ isUserAuthed }=useAuth();
    const history = useHistory();
    useEffect(() => {
        //URL handled when the menu items change due to subBuyerAdmin
        if ((sessionStorage.getItem('selectedissubbuyeradmin') && sessionStorage.getItem('selectedissubbuyeradmin')?.toString() === "true" && (path === '/' || path !== '/multi-budget-admin' && path !== '/multi-supplier-admin' && path !== '/multi-application-report' && path !== '/multi-job-admin' && path !== '/multi-candidate-admin' && path !== '/multi-budgets' && path !== '/multi-click-report' && path !== '/multi-dashboard' && path !== '/multi-cost-center' && path !== '/multi-priority-filters' && path !== '/multi-priority-rules' && path !== '/your-jobs-admin' && path !== '/boost-orders-admin' && path !== '/boost-orders-finance' && path !== '/multi-orders' && path !== '/multi-billing-finance' && path !== '/multi-orders-admin-cs' && path !== '/multi-orders-admin' && path !== '/landing-page' && path !== '/analysis' && path !== '/view-report/:reportId')) ||
            ( sessionStorage.getItem('selectedissubbuyeradmin') && sessionStorage.getItem('selectedissubbuyeradmin')?.toString()==="false" && ( path === '/' || path === '/multi-budget-admin' || path === '/multi-supplier-admin' || path === '/multi-application-report' || path === '/multi-job-admin' || path==='/multi-candidate-admin' || path==='/multi-budgets' || path==='/multi-click-report' || path==='/multi-dashboard' || path==='/multi-cost-center' || path==='/multi-priority-filters' || path==='/multi-priority-rules' || path==='/your-jobs-admin' || path==='/boost-orders-admin' || path==='/boost-orders-finance' ||	path==='/multi-orders' ||	path==='/multi-billing-finance' ||	path==='/multi-orders-admin-cs' ||	path==='/multi-orders-admin' ))) {
                if(path!=='/DownloadFile' && path!=='/settings' &&  path!=='/activity-logs' && path!=='/bulk-hire'&& path!=='/set-bulk-hire' &&	path!=='/chatbotdomainconfigure' &&	path!=='/set-bulk-interview' &&	path!=='/orders' &&	path!=='/billing-finance' &&	path!=='/orders-admin-cs' &&	path!=='/orders-admin'  && path!=='/welcome'){
                    history.replace("/");
                }
            }
      }, [path, history]);

    if (!isUserAuthed()){
        // return <Redirect to="/login" />
        history.replace("/login");
    }
    let selectedComponent = component;
    const cookieValue = sessionStorage.getItem('selectedissubbuyeradmin')?.toString();
    let loggedInBuyer=Cookies.get(constants.COOKIE_LOGGED_BUYER_NAME)?.toLowerCase();
    let SelectedBuyer=sessionStorage.getItem("selectedbuyername")?.toLowerCase();
    if (cookieValue === "true") {
        if (path === '/' || path === '/welcome' || (path !== '/multi-budget-admin' && path !== '/multi-supplier-admin' && path !== '/multi-application-report' && path !== '/multi-job-admin' && path !== '/multi-candidate-admin' && path !== '/multi-budgets' && path !== '/multi-click-report' && path !== '/multi-dashboard' && path !== '/multi-cost-center' && path !== '/multi-priority-filters' && path !== '/multi-priority-rules' && path !== '/your-jobs-admin' && path !== '/boost-orders-admin' && path !== '/boost-orders-finance' && path !== '/multi-orders' && path !== '/multi-billing-finance' && path !== '/multi-orders-admin-cs' && path !== '/multi-orders-admin' && path !== '/landing-page' && path !== '/analysis' && path !== '/view-report/:reportId')){
            if(path==='/DownloadFile'|| path==='/settings' || path==='/activity-logs'|| path==='/bulk-hire'|| path==='/set-bulk-hire'|| path==='/chatbotdomainconfigure' || path==='/set-bulk-interview' || path==='/orders' || path==='/billing-finance' || path==='/orders-admin-cs' || path==='/orders-admin' || path==='/welcome'){
                selectedComponent= component;
            }else{
                if(loggedInBuyer?.includes("hi admin")&&loggedInBuyer===SelectedBuyer){
                    selectedComponent = MultiCostCenter;
                }else if(Cookies.get(constants.COOKIE_IS_RECRUITER)===true||Cookies.get(constants.COOKIE_IS_RECRUITER)==="true"){
                    selectedComponent = MultiCandidateAdmin;
                }else{
                    selectedComponent = MultiYourJobsContainer;
                }
            }
        }
    }else{
        if(path === '/welcome'){
            selectedComponent = component;
        }else if(path === '/' || path === '/multi-budget-admin' || path === '/multi-supplier-admin' || path === '/multi-application-report' || path === '/multi-job-admin' || path ==='/multi-candidate-admin' || path ==='/multi-budgets' || path==='/multi-click-report' || path==='/multi-dashboard' || path==='/multi-cost-center' || path==='/multi-priority-filters' || path==='/multi-priority-rules' || path==='/your-jobs-admin' || path==='/boost-orders-admin' || path==='/boost-orders-finance' || path==='/multi-orders' || path==='/multi-billing-finance' || path==='/multi-orders-admin-cs' || path==='/multi-orders-admin' ){
            if(Cookies.get(constants.COOKIE_IS_RECRUITER)===true||Cookies.get(constants.COOKIE_IS_RECRUITER)==="true"){
                selectedComponent= Candidates;
            }else{
                selectedComponent = YourJobsContainer;
            }
        }
    }

  return (
      <Route
          {...rest}
          render={(props) =>
              React.createElement(
                  layout,
                  {
                      ...props,
                      ...rest
                  },
                  React.createElement(selectedComponent, {
                      ...props,
                      ...rest
                  })
              )
          }
      />
      
  );
}
